import { useMedia } from "@next-platform/client-common-spicy-ui";
import { useApp } from "@next-platform/client-common-core";

import { useTheme } from "@/hooks";
import { cn } from "@/utils";

import { Row } from "../customComponents";

interface SiteLogoProps {
  className?: string;
  type?: "logo" | "icon";
  theme?: "dark" | "light";
}

export function SiteLogo({ className, type = "logo", theme }: SiteLogoProps) {
  const { branding, applicationName } = useApp();
  const { isDark } = useTheme();
  const { logoDesktopDark, logoMobileDark, logoMobileLight, logoDesktopLight, logoDark, logoLight } = branding || {};
  const { isMobile } = useMedia();
  const isDarkTheme = theme ? theme === "dark" : isDark;

  const logo = (() => {
    if (isDarkTheme) {
      if (type === "icon") {
        return logoLight;
      }
      return isMobile ? logoMobileLight : logoDesktopLight;
    }

    if (type === "icon") {
      return logoDark;
    }
    return isMobile ? logoMobileDark : logoDesktopDark;
  })();

  const logoSize = type === "logo" ? "h-5" : "h-11";

  return (
    <Row className="items-center">{!!logo && <img src={logo || ""} className={cn(logoSize, className)} alt={applicationName ?? "site-logo"} />}</Row>
  );
}
